<div class="row">
  <div class="col-xs-12">
    <form #emailRegistrationForm="ngForm" [formGroup]="emailRegistrationGroup">
      <form #emailVerificationForm="ngForm"
            (ngSubmit)="submitEmailVerificationRequest(emailVerificationRequestGroup)"
            [formGroup]="emailVerificationRequestGroup">
        <p class="form-field-heading">Email Id</p>
        <mat-form-field class="full-width">
          <input matInput [(ngModel)]="email"
                 formControlName="email"
                 (input)="onEmailIdChange()"
                 title="Please provide a valid email"
                 type="email" placeholder="We only use this for relevant updates and information" [readonly]="shouldEmailFieldDisabled">
          <button mat-stroked-button matSuffix class="btn-input-suffix" [disabled]="isVerifyButtonDisabled"
                  type="submit" (click)="analyticsTracker.trackButtonClick( 'Email Verification' , verifyButtonTitle)" >
            {{verifyButtonTitle}}
          </button>
          <mat-error *ngIf="emailFormControl.invalid">
            {{ getErrorMessage(emailFormControl) }}
          </mat-error>
        </mat-form-field>
      </form>

      <div *ngIf="emailVerificationRequested">
        <p class="form-field-heading">Enter your verification code</p>
        <mat-form-field class="full-width">
          <input matInput
                 formControlName="verificationCode"
                 title="Please enter the verification code"
                 type="text" placeholder="Please enter the verification code sent to your email">
          <mat-error *ngIf="verificationCodeFormControl.invalid">
            {{ getErrorMessage(verificationCodeFormControl) }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>
</div>
